import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustStats } from '../components/TrustStats';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { ServiceArea } from '../components/ServiceArea';
import { CTABanner } from '../components/CTABanner';
import { AlertTriangleIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function HomePage() {
  return <main data-id="element-304">
      <HeroSection data-id="element-305" />

      {/* Emergency Delivery Spotlight */}
      <section className="bg-red-600 text-white py-12 relative z-20" data-id="element-306">
        <div className="container mx-auto px-4" data-id="element-307">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-308">
            <div className="lg:w-1/2" data-id="element-309">
              <div className="flex items-center gap-3 mb-4" data-id="element-310">
                <AlertTriangleIcon className="h-8 w-8 text-red-200" data-id="element-311" />
                <h2 className="text-3xl font-bold" data-id="element-312">
                  Specialists in Emergency Parcel Delivery
                </h2>
              </div>
              <p className="text-red-100 text-lg leading-relaxed" data-id="element-313">
                When time is critical, you need a partner you can trust. We
                prioritize emergency and urgent parcel deliveries above all
                else, ensuring your most important items reach their destination
                immediately.
              </p>
            </div>
            <div className="lg:w-1/2 flex flex-col sm:flex-row gap-6" data-id="element-314">
              <div className="bg-white/10 p-6 rounded-xl border border-white/20 flex-1" data-id="element-315">
                <ClockIcon className="h-8 w-8 text-white mb-3" data-id="element-316" />
                <h3 className="font-bold text-xl mb-2" data-id="element-317">Same-Day Dispatch</h3>
                <p className="text-red-100 text-sm" data-id="element-318">
                  Immediate collection and direct routing to destination.
                </p>
              </div>
              <div className="bg-white/10 p-6 rounded-xl border border-white/20 flex-1" data-id="element-319">
                <ShieldCheckIcon className="h-8 w-8 text-white mb-3" data-id="element-320" />
                <h3 className="font-bold text-xl mb-2" data-id="element-321">Dedicated Vehicles</h3>
                <p className="text-red-100 text-sm" data-id="element-322">
                  Your parcel travels alone for maximum speed and security.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TrustStats data-id="element-323" />
      <AboutSection data-id="element-324" />
      <ServicesSection data-id="element-325" />
      <WhyChooseUs data-id="element-326" />
      <Testimonials data-id="element-327" />
      <ServiceArea data-id="element-328" />
      <CTABanner data-id="element-329" />
    </main>;
}